import React from "react";
import '../../App.css';
import Footer from "../../components/Footer";
//import { useOutletContext } from "react-router-dom";



function Dashboard() {
//const [count, Setcount] = useOutletContext();
//const increment = () => Setcount((count) = count + 1) ;
    return  <>  
    <div>
    <h1>host welcomes you</h1>
    </div>
    <Footer/>
     </>
}

export default Dashboard;

//<button onClick={increment}>{count}</button>